var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('notification'),_vm._v(" "),_c('v-main',[_c('transition',[_c('Nuxt')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }